/* ============================================================
   FLAVORPIX™ MOMENTS — assets/fp-moments.js
   ------------------------------------------------------------
   Au clic sur une card, on synchronise le flavor global
   (et le Flavor Selector va automatiquement répondre)
   + scroll smooth vers le selector pour montrer le résultat.
   ============================================================ */

(function () {
  'use strict';

  const cards = document.querySelectorAll('[data-fp-moment-flavor]');
  if (!cards.length) return;

  cards.forEach((card) => {
    card.setAttribute('tabindex', '0');
    card.setAttribute('role', 'button');

    const flavor = card.getAttribute('data-fp-moment-flavor');
    const label = card.querySelector('.fp-moments__card-title')?.textContent || flavor;
    card.setAttribute('aria-label', `Sélectionner la saveur ${label}`);

    const handleActivate = (e) => {
      // Si clavier, on autorise Enter et Space
      if (e.type === 'keydown' && e.key !== 'Enter' && e.key !== ' ') return;
      if (e.type === 'keydown') e.preventDefault();

      if (window.flavorpix) {
        window.flavorpix.setFlavor(flavor);
      }

      // Scroll vers le selector (sauf si on est déjà à proximité)
      const selector = document.getElementById('flavor-selector');
      if (selector) {
        const rect = selector.getBoundingClientRect();
        const isAlreadyVisible = rect.top > -100 && rect.top < window.innerHeight * 0.5;
        if (!isAlreadyVisible) {
          selector.scrollIntoView({
            behavior: prefersReducedMotion() ? 'auto' : 'smooth',
            block: 'start'
          });
        }
      }
    };

    card.addEventListener('click', handleActivate);
    card.addEventListener('keydown', handleActivate);
  });

  function prefersReducedMotion() {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }
})();
